import { type RefObject } from 'react';
import type { IChartApi } from 'lightweight-charts';
import { useChartPaneOverlayPosition } from '@/lib/chartPaneOverlay';
import { FundingInfoStrip, type FundingInfoStripProps } from './FundingInfoStrip';
import './FundingInfoStrip.css';

const FUNDING_PANE_INDEX = 2;

type Props = FundingInfoStripProps & {
  chartRef: RefObject<IChartApi | null>;
  chartContainerRef: RefObject<HTMLDivElement | null>;
  enabled: boolean;
  fundingPaneCollapsed: boolean;
  chartRevision?: number;
};

export function FundingChartOverlay({
  chartRef,
  chartContainerRef,
  enabled,
  fundingPaneCollapsed,
  chartRevision = 0,
  ...stripProps
}: Props) {
  const top = useChartPaneOverlayPosition({
    chartRef,
    chartContainerRef,
    enabled,
    paneCollapsed: fundingPaneCollapsed,
    paneIndex: FUNDING_PANE_INDEX,
    chartRevision,
  });

  if (!enabled || fundingPaneCollapsed || top == null) {
    return null;
  }

  return (
    <div className="realtime-spread-funding-chart-overlay" style={{ top: `${top}px` }}>
      <FundingInfoStrip {...stripProps} variant="chart" />
    </div>
  );
}
